import koLocale from 'element-ui/lib/locale/lang/ko'// element 언어 팩 도입
const ko = {
    Login: {
        ToLogin: '로그인',
        PhoneLogin: '핸드폰 번호 로그인',
        EmailLogin: '메일박스 로그인',
        PhonePlaceholder: '핸드폰 번호를 입력하세요.',
        EmailPlaceholder: 'Enter email',
        Code: '인증 코드',
        and: '및',
        BeforeText: '계좌를 만드는 동시에 당신이 동의하고 준수하는 것을 대표합니다',
        UserAgreement: '사용자 프로토콜',
        privacy: '개인 정보 보호 정책',
        errorMessage: '인증 코드 오류',
        readTitle: '다음 계약을 읽고 동의합니다.',
        readBefore: '귀하의 개인 정보를 안전하게 보호하려면 먼저 읽고 동의하십시오.',
        cancel: '취소',
        agree: '동의 및 계속 ',
        error1: '올바른 이메일 주소를 입력하십시오.',
        error2: '정확한 핸드폰 번호를 입력하세요.',
        error3: '인증 코드를 입력하십시오.',
        success: '로그인 성공'
    },
    ...koLocale // 언어를 전환할 때 element 구성 요소의 텍스트가 전환에 따라 이동할 수 있도록 element 언어 팩을 도입합니다
}
// 내보내기
export default ko;
